import Grid from "@mui/material/Grid";
import { styled } from "@mui/system";

const StyledWrapper = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  alignItems: "flex-start",
  columnGap: "32px",
  rowGap: "60px",
  width: "100%",
  margin: "0 auto",
  [theme.breakpoints.down("lg")]: {
    columnGap: "24px",
    rowGap: "50px",
  },
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    columnGap: 0,
    rowGap: 0,
  },
}));

export default StyledWrapper;
